import isNaN from 'lodash/isNaN';

export default (weight) => {
  const w = parseFloat(weight);
  if (isNaN(w) || w === 0) {
    return '—';
  }
  if (w < 1000) {
    return '<1k';
  }
  return `${Math.trunc(w / 1000)}k`;
};



// WEBPACK FOOTER //
// ./src/misc/weight.js